export const API_ENDPOINTS = {
  TECHSTACKCONTROL: {
    FETCH: "/techstackcontrol/fetch",
    SEARCH: "/techstackcontrol/search",
    GET: "/techstackcontrol/get",
    CREATE: "/techstackcontrol/create",
    UPDATE: "/techstackcontrol/update",
    DELETE: "/techstackcontrol/delete",
  },

  RISKREGISTER: {
    FETCH: "/riskregister/fetch",
    SEARCH: "/riskregister/search",
    GET: "/riskregister/get",
    ORGANIZATIONS: "/riskregister/organizations",
    ASSETS: "/riskregister/assets",
    CREATE: "/riskregister/create",
    UPDATE: "/riskregister/update",
    DELETE: "/riskregister/delete",
    TEF_GET: "/riskregister/threat-event-frequency/get",
    TEF_CREATE: "/riskregister/threat-event-frequency/create",
    TEF_UPDATE: "/riskregister/threat-event-frequency/update",
    VULNERABILITY_GET: "/riskregister/vulnerability/get",
    VULNERABILITY_CREATE: "/riskregister/vulnerability/create",
    VULNERABILITY_UPDATE: "/riskregister/vulnerability/update",
    LEF_GET: "/riskregister/loss-event-frequency/get",
    LEF_CREATE: "/riskregister/loss-event-frequency/create",
    LEF_UPDATE: "/riskregister/loss-event-frequency/update",
    ALF_GET: "/riskregister/asset-loss-factors/get",
    ALF_CREATE: "/riskregister/asset-loss-factors/create",
    ALF_UPDATE: "/riskregister/asset-loss-factors/update",
    TLF_GET: "/riskregister/threat-loss-factors/get",
    TLF_CREATE: "/riskregister/threat-loss-factors/create",
    TLF_UPDATE: "/riskregister/threat-loss-factors/update",
    OLF_GET: "/riskregister/organizational-loss-factors/get",
    OLF_CREATE: "/riskregister/organizational-loss-factors/create",
    OLF_UPDATE: "/riskregister/organizational-loss-factors/update",
    ELF_GET: "/riskregister/external-loss-factors/get",
    ELF_CREATE: "/riskregister/external-loss-factors/create",
    ELF_UPDATE: "/riskregister/external-loss-factors/update",
    LM_GET: "/riskregister/loss-magnitude/get",
    LM_CREATE: "/riskregister/loss-magnitude/create",
    LM_UPDATE: "/riskregister/loss-magnitude/update",
  },
};
